export default __webpack_public_path__ + "static/media/MY_TRACKER_IMG.037f6f31.jpg";